import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleCategorySearchDto } from '../../vehicle-categories';
import { RentalReservationRecordCategoryEnum } from '../enums/rental-reservation-record-category.enum';
import { RentalReservationStatusEnum } from '../enums/rental-reservation-status.enum';

import { RentalReservationLinksDto } from './rental-reservation-links.dto';

/**
 * Rental reservation search DTO
 */
@CaslSubject(AppSubjectEnum.RENTAL_RESERVATION)
export class RentalReservationSearchDto extends BaseSearchDto {
  code?: string | null;
  recordCategory?: RentalReservationRecordCategoryEnum | null;
  qrCode?: string | null;
  status?: RentalReservationStatusEnum | null;
  startsAt?: Date | null;
  endsAt?: Date | null;
  vehicleId?: number | null;
  vehicleCategoryId?: number | null;
  vehicleCategory?: VehicleCategorySearchDto | null;
  pickupLocationId?: number | null;
  dropOffLocationId?: number | null;
  agentId?: number | null;
  agentContactShortName?: string | null;
  vehicleLicensePlate?: string | null;
  vehicleCategoryName?: string | null;
  vehicleVin?: string | null;
  links?: RentalReservationLinksDto | null;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
